exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3tgMgfAsBJoUAWDQAmFPgF{-webkit-box-shadow:0 -2px 1px -2px \"[theme:neutralDark, default:#212121]\";box-shadow:0 -2px 1px -2px \"[theme:neutralDark, default:#212121]\"}._1jKJ0Xn6cfDf4GZ5UcU4Os{position:fixed;pointer-events:\"none\";z-index:1000;top:0;font-size:12px;font-weight:400}html[dir] ._1jKJ0Xn6cfDf4GZ5UcU4Os{border-width:1px;border-style:solid;padding:0 4px;background-color:\"[theme:white, default:#ffffff]\"}html[dir=ltr] ._1jKJ0Xn6cfDf4GZ5UcU4Os{left:0}html[dir=rtl] ._1jKJ0Xn6cfDf4GZ5UcU4Os{right:0}", ""]);

// exports
exports.locals = {
	"showBorderOnDroppedOver": "_3tgMgfAsBJoUAWDQAmFPgF",
	"dragHelperStyle": "_1jKJ0Xn6cfDf4GZ5UcU4Os"
};